import { css } from "styled-components";

export const sharedLabelStyles = css`
	font-family: Open Sans, sans-serif;
	text-align: center;
	font-style: normal;
	font-weight: 600;
	line-height: 20px;
`;
